export type CalendarStatusSeverity = 'warning' | 'success' | 'validation' | 'info';

export interface CalendarStatusMessage {
  severity: CalendarStatusSeverity;
  text: string;
}

export function calendarStatusLaneClasses(message: CalendarStatusMessage | null): string {
  const baseClasses =
    'min-h-9 border-b border-edge px-4 py-2 text-xs flex items-center transition-colors';
  if (!message) {
    return `${baseClasses} bg-surface text-transparent`;
  }

  switch (message.severity) {
    case 'success':
      return `${baseClasses} bg-status-success-surface text-status-success-fg`;
    case 'validation':
      return `${baseClasses} bg-status-validation-surface text-status-validation-fg`;
    case 'info':
      return `${baseClasses} bg-status-info-surface text-status-info-fg`;
    case 'warning':
      return `${baseClasses} bg-status-warning-surface text-status-warning-fg`;
  }
}
